import { useCallback } from "react";
import { useSelector } from "react-redux";
import { selectTherapistGender } from "../../../store/slices/authSlice";

/**
 * useGenderText
 * --------------------------------------------------------------
 * Returns a `g(male, female)` helper that picks the right Hebrew form for the
 * signed-in therapist's gender. Anything other than "female" (male / other /
 * unknown) falls back to the masculine form. Used to address the therapist in
 * gender-correct Hebrew throughout the catch-up flow.
 */
export default function useGenderText() {
  const gender = useSelector(selectTherapistGender);
  return useCallback((male, female) => (gender === "female" ? female : male), [
    gender,
  ]);
}
